import { useState } from 'react';

import ResourceModal from 'app/components/ResourceModal';
import ResourceModalPanel from 'app/components/ResourceModalPanel';
import MessageModal from 'app/components/MessageModal';
import AccountPricingForm from './AccountPricingForm';

const AccountPricingPanel = props => {
  const {
    accountPricing,
    action,
    onClose,
    onDelete
  } = props;

  // if we're creating a customer then no actions panel will be shown
  if (action === 'create') {
    return null;
  }

  let cards = [
    {
      label: 'Delete Account Pricing',
      message: 'Removes the Account Pricing.',
      actions: [
        { label: 'Delete Account Pricing', callback: onDelete }
      ]
    }
  ]

  return (
    <div>
      <ResourceModalPanel cards={cards} />
    </div>
  )
}

const AccountPricingModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    onDestroy,
    accountPricing
  } = props;
  const [error, setError] = useState(null);

  let title, subTitle = null;

  if (accountPricing) {
    title = accountPricing.billing_name;
  } else {
    title = 'New Account Billing';
  }

  const action = accountPricing ? 'update' : 'create';

  const onSubmit = params => {
    if (!params.account_id) {
      setError('Please select an account');
      return;
    }
    onFormSubmit(action, params).catch((ex) => {
      setError(ex.error);
    })
  };

  const onDelete = () => onDestroy(accountPricing.id);

  return (
    <div>
      <ResourceModal {...{ isOpen, onClose, title, subTitle }}>
        <AccountPricingPanel {...{ accountPricing, action, onClose, onDelete }} />
        <AccountPricingForm {...{ accountPricing, action, onClose, onSubmit }} />
      </ResourceModal>
      <MessageModal
        isOpen={error !== null}
        onClose={() => setError(null)}
        title='Account Pricing'
        message={error}
      />
    </div>
  );

}

export default AccountPricingModal
